<template>
	<div>
    <!--绑定当前颜色-->
    <el-color-picker v-model="colorValue" @change="handleChange" :predefine="predefineColors">
    </el-color-picker>
    <!--展示当前颜色-->
		<span style="margin-left: 10px;">{{colorValue}}</span>
	</div>
</template>

<script>
	export default{
		name: "ColorPickerComponent",    // 颜色选择框
		props:{
			value: {},
		},
    data() {
      return {
        predefineColors: [
          '#000000',
          '#ffffff',
          '#ff4500',
          '#ff8c00',
          '#ffd700',
          '#90ee90',
          '#00ced1',
          '#1e90ff',
          '#c71585',
        ]
      }
    },
		methods:{
      // 颜色修改时触发
			handleChange(val) {
        this.$emit('change', val)
			},
		},
		computed:{
			colorValue:{
				get() {
          return this.value+''  // 解决报错undefined
        },
        set(val) {
          this.$emit("input", val)
        }
			}
		}
	}
</script>

<style>
</style>
